import { Button as FUIButton } from '@bsf/force-ui';
import { forwardRef } from '@wordpress/element';

/**
 * Button Component
 *
 * A wrapper around Force UI Button with customizable variant and onClick handler.
 *
 * @param {string} text - Button text
 * @param {string} variant - Button variant (primary|secondary|tertiary)
 * @param {Function} onClick - Click handler function
 */
const Button = ( { text, variant, onClick } ) => {
	const handleOnClick = ( event ) => {
		if ( !! onClick && typeof onClick === 'function' ) {
			onClick( event );
		}
	};

	return (
		<FUIButton
			variant={ variant || 'primary' }
			size="sm"
			onClick={ handleOnClick }
		>
			{ text }
		</FUIButton>
	);
};

export default forwardRef( Button );
